import { CorpSessionInfo, SessionInfo, Tenant } from "redmond";
import { platformApiApi } from "@capone/platform-api";
import { config } from "../config";
import { mcLeanAxiosInstance } from "../../components/AxiosInterceptors";
import {
  getValidatedRedirectUrl,
  isLocalHostname,
  X_REDIRECT_TO_HEADER,
} from "../../utils/redirectUtils";

export const fetchUserInfo = <T extends Tenant>(): Promise<
  T extends "capone-corporate" | "brex" ? CorpSessionInfo : SessionInfo
> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await platformApiApi(mcLeanAxiosInstance).apiV0UserInfoGet({
        baseURL: config.baseURL,
      });

      // Authenticated APIs return an X-Redirect-To header when the user's
      // tenant does not match the portal they're visiting (e.g. a leisure user
      // on the vesper portal). When present and trusted, send them there —
      // except during local development, where the header carries the deployed
      // portal URL and would navigate the developer off of localhost.
      const redirectUrl = getValidatedRedirectUrl(
        res.headers?.[X_REDIRECT_TO_HEADER]
      );
      if (redirectUrl && !isLocalHostname(window.location.hostname)) {
        window.location.assign(redirectUrl);
        return;
      }

      resolve(
        res.data as T extends "capone-corporate" | "brex"
          ? CorpSessionInfo
          : SessionInfo
      );
    } catch (e) {
      reject(e);
    }
  });

export default fetchUserInfo;
